import { render, staticRenderFns } from "./MailControl.vue?vue&type=template&id=38937934&scoped=true&"
import script from "./MailControl.vue?vue&type=script&lang=js&"
export * from "./MailControl.vue?vue&type=script&lang=js&"
import style0 from "./MailControl.vue?vue&type=style&index=0&id=38937934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38937934",
  null
  
)

export default component.exports